import { ElementType } from '@fiverr-private/bianka_js';
import { StepSlug, Store } from '@fiverr-private/store_builder_types';
import {
    BiEventData,
    EventType,
    getStoreByElementName,
    ReportBiEventParams,
    stepMetaMap,
    reportBiEvent,
} from '@fiverr-private/store_builder_bi_events';
import { TabbedCarouselTabClickData } from '@fiverr-private/personalized_content/dist/esm/src/PersonalizedContent/components/TabsView/types';

export interface ClickEventData {
    biEventData: BiEventData;
    eventType: EventType;
    elementType: ElementType;
    currentPath: StepSlug;
    store?: Partial<Store> | undefined;
    tabbedCarouselTabClickData?: TabbedCarouselTabClickData;
}

export const reportClickEvent = ({
    biEventData,
    eventType,
    elementType,
    currentPath,
    store = {},
    tabbedCarouselTabClickData,
}: ClickEventData) => {
    const reportParams: ReportBiEventParams = {
        biEventData,
        store: getStoreByElementName(store, currentPath),
        activityType: 'click',
        eventType,
        elementName: stepMetaMap[currentPath].name,
        elementType,
        pageName: 'bys_wizard_funnel',
        tabbedCarouselTabClickData,
    };

    reportBiEvent(reportParams);
};
